import { Component, OnDestroy, OnInit } from '@angular/core';
import { AssigTripsService } from '../../../assigntrips-service/assigntrips-service';
import { DriversService } from 'src/app/component/drivers/drivers-service/drivers-service';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { takeUntil } from 'rxjs/operators';
import { sweetAlert } from 'src/app/utils/swal';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import * as moment from 'moment';
import { ServiceAreasService } from 'src/app/component/service-areas/service-areas-service/service-areas.service';

@Component({
  selector: 'app-planner-driver-mapper-list',
  templateUrl: './planner-driver-mapper-list.component.html',
  styleUrls: ['./planner-driver-mapper-list.component.css']
})
export class PlannerDriverMapperListComponent implements OnInit, OnDestroy {
  search = "";
  templates = [];
  user;
  preDriver = {};
  timeZone;
  todayDate;
  days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  preServiceAreas = {};
  constructor(
    private assignTripsService: AssigTripsService,
    private driverService: DriversService,
    private sharedDataService: SharedDataService,
    private serviceArea: ServiceAreasService
  ) { }

  ngOnInit() {
    this.getUser();
  }

  getUser() {
    this.sharedDataService.getUser().subscribe(data => {
      if (data) {
        this.user = data;
        this.timeZone = data.timeZone;
        this.todayDate = moment().tz(this.timeZone).toISOString()
        this.getDriverList();
        this.getServiceAreas();
      }
    })
  }

  getTemplates() {
    this.assignTripsService
      .getDriverPlannerTemplates()
      .subscribe(data => {
        if (data && data.length) {
          this.templates = data;
          this.templates = this.templates.map(template => {
            return {
              ...template,
              driver: this.preDriver[template.driver]
            };
          });
      }
    });
  }

  getDriverList() {
    this.driverService.getDrivers(this.user._id, 'active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.preDriver = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
            this.getTemplates();

          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "OK");
        }
      );
  }

    currentDayShift(shifts) {
      const currentDay = moment(this.todayDate).tz(this.timeZone).day();
      if (shifts) {
        let shift = shifts.find(shift => shift.day === currentDay);
        return shift;
      } else {
        return {};
      }
    }


  getServiceAreas() {
    this.serviceArea.getServiceAreas({ status: 'active' })
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.preServiceAreas = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
        });
    }

  ngOnDestroy(): void {

  }

}
